import { MenuItem } from '@material-ui/core';
import { FormikTextField } from '@superdispatch/forms';
import { mileToKm } from 'shared/modules/loadboard/LoadboardUtils';

const outOfRouteDistanceOptions = [
  { text: '25 mi', value: '' },
  { text: '50 mi', value: mileToKm(50) },
  { text: '100 mi', value: mileToKm(100) },
];

export function LATROffRouteDistanceField() {
  return (
    <FormikTextField
      select={true}
      defaultValue=""
      name="search_criteria.distance_off_route"
      label="Out of Route Distance"
      fullWidth={true}
      SelectProps={{ displayEmpty: true }}
    >
      {outOfRouteDistanceOptions.map((item) => (
        <MenuItem key={item.text} value={item.value}>
          {item.text}
        </MenuItem>
      ))}
    </FormikTextField>
  );
}
